<template>
  <MuiForm
    v-model="formData"
    class="SignUpEmployeeStep3 Step__form"
    @submit.native="submit"
  >
    <h1 class="font-normal m-xs-b">
      {{ $t('Views.user_signup.step_3.title') }}
    </h1>
    <div class="m-s-b">
      {{ $t('Views.user_signup.step_3.subtitle') }}
    </div>
    <!-- Title -->
    <MuiSelect
      :value="data.title"
      :label="$t('Views.user_signup.step_3.fields.title')"
      :placeholder="$t('Views.user_signup.step_3.fields.title_placeholder')"
      :on-change="(e) => title(e)"
      name="title"
      object-label="name"
      object-value="internal_name"
      size="l"
      required
    >
      <MuiSelectItem
        v-for="title in ubeeqoTitles"
        :key="title.internal_name"
        :value="title"
      >
        {{ title.name }}
      </MuiSelectItem>
    </MuiSelect>
    <!-- End Title -->
    <!-- FirstName -->
    <MuiInputText
      :label="$t('Views.user_signup.step_3.fields.first_name')"
      :placeholder="$t('Views.user_signup.step_3.fields.first_name_placeholder')"
      :on-change="(e, v) => firstName(v)"
      :value="data.firstName"
      name="firstName"
      required
      full-width
    />
    <!-- End FirstName -->
    <!-- Last Name -->
    <MuiInputText
      :label="$t('Views.user_signup.step_3.fields.last_name')"
      :placeholder="$t('Views.user_signup.step_3.fields.last_name_placeholder')"
      :on-change="(e, v) => lastName(v)"
      :on-blur="() => $segments.trackSegment('Name Created', { name: data.firstName, lastName: data.lastName})"
      :value="data.lastName"
      name="lastName"
      required
      full-width
    />
    <!-- End Last Name -->
    <!-- BirthDate -->
    <MuiDate
      v-model="initialDate"
      :label="$t('Views.user_signup.step_3.fields.birth_date')"
      :min-date="minDate"
      :max-date="maxDate"
      :initial-value="data.birthDate"
      :custom-error-messages="{
        maxDate: $t('Views.user_signup.step_3.fields.min_driver_age')
      }"
      label-class="font-s"
      name="birthDate"
      required
      @change="trackBirthdate"
      @date="(e) => birthDate(e)"
    />
    <!-- End BirthDate -->
    <MuiButtonFlat
      submit
      class="Step__form__next-button m-s-b"
    >
      {{ $t('Views.user_signup.step_3.button') }}
    </MuiButtonFlat>
  </MuiForm>
</template>
<script>
import {
  mapMutations,
  mapState,
} from 'vuex';

import {
  MuiDate,
  MuiInputText,
  MuiSelect,
  MuiSelectItem,
  MuiForm,
  MuiButtonFlat,
} from '@ubeeqo/motion-ui';

import moment from 'moment';
import { DATE_FORMAT } from '@ubeeqo/web-utils';

import { GENERAL_MODULE, EMPLOYEE_MODULE } from '@/constants/modules';
import { steps } from '../constants';

export default {
  name: 'SignUpEmployeeStep3View',
  components: {
    MuiForm,
    MuiInputText,
    MuiSelect,
    MuiSelectItem,
    MuiButtonFlat,
    MuiDate,
  },
  data() {
    return {
      formData: {},
      initialDate: {
        day: '',
        month: '',
        year: '',
      },
    };
  },
  computed: {
    ...mapState(GENERAL_MODULE, {
      ubeeqoTitles: state => state.titles,
    }),
    ...mapState(EMPLOYEE_MODULE, {
      done: state => state.done,
      data: state => state.data,
    }),
    minDate() {
      return moment().subtract(90, 'years').toDate();
    },
    maxDate() {
      return moment().subtract(18, 'years').toDate();
    },
  },
  watch: {
    formData(value) {
      if (value.valid) {
        this.doneStep(this.$options.name);
      } else {
        this.unDoneStep(this.$options.name);
      }
    },
  },
  beforeMount() {
    this.initialDate = (this.data.birthDate && new Date(this.data.birthDate)) || this.initialDate;
  },
  mounted() {
    if (!this.done.step1) {
      this.$router.push('./step1');
    }
  },
  methods: {
    ...mapMutations(EMPLOYEE_MODULE, [
      'title',
      'firstName',
      'lastName',
      'birthDate',
      'doneStep',
      'unDoneStep',
      'updateStep',
    ]),
    submit() {
      if (this.$data.formData.valid) {
        this.doneStep(steps.step3);
        this.updateStep(steps.step4);
        this.$router.push('./step4');
      } else {
        this.updateStep(steps.step3);
      }
    },
    trackBirthdate() {
      if (moment(this.data.birthDate).isValid()) {
        this.$segments.trackSegment('Birthdate Added', moment(this.data.birthDate).format(DATE_FORMAT.date));
      }
    },
  },
};
</script>
